if (!window.RitualPremiumCartReady) {
  window.RitualPremiumCartReady = true;

  const root = () => window.Shopify?.routes?.root || '/';
  const reservationKey = 'ritual-cart-reservation-end-v1';
  let reservationEnd = null;
  let reservationInterval = null;
  let lastCartCount = null;
  let observedItems = null;
  let cueFrame = null;

  const openCart = () => document.querySelector('#cart-drawer[open]');
  const cartCount = () => Number(document.querySelector('#cart-drawer .theme-drawer__badge')?.textContent?.trim()) || 0;
  const resetReservation = (timer) => {
    reservationEnd = Date.now() + Math.max(1, Number(timer.dataset.minutes) || 10) * 60000;
    try { sessionStorage.setItem(reservationKey, String(reservationEnd)); } catch (_error) {}
  };

  const updateScrollCue = () => {
    cueFrame = null;
    const drawer = openCart();
    const items = drawer?.querySelector('.rpc-items-wrap .cart-drawer__items');
    const cue = drawer?.querySelector('[data-rpc-scroll-cue]');
    if (!items || !cue) return;
    cue.hidden = items.scrollHeight - items.clientHeight - items.scrollTop <= 12;
    if (items !== observedItems && typeof ResizeObserver !== 'undefined') {
      observedItems = items;
      resizeObserver?.disconnect();
      resizeObserver?.observe(items);
    }
  };

  const requestScrollCue = () => {
    if (cueFrame !== null) return;
    cueFrame = requestAnimationFrame(updateScrollCue);
  };
  const resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(requestScrollCue);

  const reservationClock = () => {
    const timer = document.querySelector('#cart-drawer[open] [data-rpc-reservation]');
    if (!timer || reservationEnd === null) return;
    const seconds = Math.max(0, Math.ceil((reservationEnd - Date.now()) / 1000));
    if (seconds === 0) {
      timer.hidden = true;
      if (reservationInterval) clearInterval(reservationInterval);
      reservationInterval = null;
      return;
    }
    const clock = timer.querySelector('[data-rpc-reservation-clock]');
    if (clock) {
      const next = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      if (clock.firstChild?.nodeType === Node.TEXT_NODE) clock.firstChild.nodeValue = next;
      else if (clock.textContent !== next) clock.textContent = next;
    }
  };

  const startReservation = (newOpening = false) => {
    const timer = openCart()?.querySelector('[data-rpc-reservation]');
    if (!timer) return;
    if (reservationEnd === null) {
      try {
        const saved = Number(sessionStorage.getItem(reservationKey));
        reservationEnd = Number.isFinite(saved) && saved > Date.now() ? saved : null;
      } catch (_error) {
        reservationEnd = null;
      }
      if (reservationEnd === null) resetReservation(timer);
    } else if (newOpening && reservationEnd <= Date.now()) {
      resetReservation(timer);
    }
    timer.hidden = false;
    reservationClock();
    if (reservationEnd > Date.now() && !reservationInterval) {
      reservationInterval = setInterval(reservationClock, 1000);
    }
  };

  document.addEventListener('theme-drawer:open', (event) => {
    if (event.target?.matches?.('#cart-drawer')) {
      startReservation(true);
      requestScrollCue();
    }
  });
  const watchCart = () => {
    const syncCart = () => {
      const count = cartCount();
      if (lastCartCount !== null && count > lastCartCount && reservationEnd !== null && reservationEnd <= Date.now()) {
        const timer = openCart()?.querySelector('[data-rpc-reservation]');
        if (timer) resetReservation(timer);
      }
      lastCartCount = count;
      if (openCart()?.querySelector('[data-rpc-reservation]')) startReservation();
      requestScrollCue();
    };
    new MutationObserver((mutations) => {
      const cartChanged = mutations.some(({ target, addedNodes, removedNodes }) =>
        target.closest?.('#shopify-section-cart-drawer-section') ||
        [...addedNodes, ...removedNodes].some((node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('#shopify-section-cart-drawer-section, #cart-drawer') || node.querySelector?.('#cart-drawer'))
        )
      );
      if (cartChanged) syncCart();
    }).observe(document.body, { childList: true, subtree: true });
    lastCartCount = cartCount();
    if (openCart()) startReservation(true);
    requestScrollCue();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart, { once: true });
  else watchCart();
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(() => {
    if (openCart()) startReservation(true);
    requestScrollCue();
  }));

  document.addEventListener('scroll', (event) => {
    if (event.target?.matches?.('.rpc-items-wrap .cart-drawer__items')) requestScrollCue();
  }, true);
  document.addEventListener('click', (event) => {
    const cue = event.target.closest?.('[data-rpc-scroll-cue]');
    if (!cue) return;
    const items = cue.closest('.rpc-items-wrap')?.querySelector('.cart-drawer__items');
    items?.scrollBy({ top: Math.max(120, items.clientHeight * .7), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  window.addEventListener('resize', requestScrollCue, { passive: true });

  const updateVariant = (select) => {
    const card = select.closest('[data-rpc-card]');
    const option = select.selectedOptions?.[0];
    if (!card || !option) return;

    const price = card.querySelector('[data-rpc-price]');
    if (price) price.textContent = option.dataset.price || '';

    const compare = card.querySelector('[data-rpc-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    const image = card.querySelector('[data-rpc-image]');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = option.dataset.image;
    }
  };

  const refreshBubble = async () => {
    const cart = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
    document.querySelectorAll('[data-testid="cart-bubble"]').forEach((bubble) => {
      bubble.textContent = cart.item_count;
      bubble.classList.toggle('hidden', cart.item_count === 0);
      bubble.closest('.cart-bubble')?.classList.toggle('visually-hidden', cart.item_count === 0);
    });
  };

  const addUpsell = async (button) => {
    const card = button.closest('[data-rpc-card]');
    const select = card?.querySelector('[data-rpc-select]');
    if (!card || !select?.value || button.disabled) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: select.value, quantity: 1 }] })
      });
      if (!response.ok) throw new Error(await response.text());

      await response.json();
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', 'cart-drawer-section');
      sectionUrl.searchParams.set('_', Date.now().toString());
      const html = await fetch(sectionUrl.toString(), { cache: 'no-store', headers: { Accept: 'text/html' } }).then((sectionResponse) => {
        if (!sectionResponse.ok) throw new Error('Cart drawer refresh failed');
        return sectionResponse.text();
      });

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('#shopify-section-cart-drawer-section');
      const current = document.querySelector('#shopify-section-cart-drawer-section');
      if (!fresh || !current) throw new Error('Cart drawer section could not be refreshed');

      const currentDrawer = current.querySelector('#cart-drawer');
      const freshDrawer = fresh.querySelector('#cart-drawer');
      if (!currentDrawer || !freshDrawer) throw new Error('Cart drawer content could not be refreshed');

      currentDrawer.replaceWith(freshDrawer);
      await refreshBubble();
      await customElements.whenDefined('theme-drawer');
      requestAnimationFrame(() => document.querySelector('#cart-drawer')?.open());
    } catch (error) {
      console.error('[Ritual cart upsell]', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-rpc-select]');
    if (select?.matches('select')) updateVariant(select);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-rpc-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    addUpsell(button);
  });
}
